import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props){ super(props); this.state = { hasError: false, error: null }; }
  static getDerivedStateFromError(error){ return { hasError: true, error }; }
  componentDidCatch(error, info){
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary] error:', error, 'info:', info);
  }
  render(){
    if (this.state.hasError) {
      return (
        <div style={{ padding: 16, fontFamily: 'monospace' }}>
          <h3>Something went wrong</h3>
          <pre>{String(this.state.error)}</pre>
        </div>
      );
    }
    return this.props.children;
  }
}